import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import SQReportListView from 'src/components/StartUp/sqReport/SQReportListView';
import SQReportPage from 'src/components/StartUp/sqReport/SQReportPage';

const initialState: any = {
  sqReportStatus: '',
  sqReportPopupValue: '',
  sqReportTabChange: '',
  showCMPArr: [
    {
      cmp: SQReportListView,
      key: 'sqreportview',
      curruntlyActive: true
    },
    {
      cmp: SQReportPage,
      key: 'sqreportpage',
      curruntlyActive: false
    }
  ],
  selectedRowData: {}
};

export const sqReport = createSlice({
  name: 'sqReport',
  initialState,
  reducers: {
    setReportCMPArr: (state: any, action: PayloadAction<string>) => {
      const tempBackArr = state.showCMPArr.map((ele: any) => {
        if (ele.key === action.payload) {
          return { ...ele, curruntlyActive: true };
        }
        return { ...ele, curruntlyActive: false };
      });
      state.showCMPArr = tempBackArr;
    },
    setSelectedRowData: (state: any, action: any) => {
      state.selectedRowData = action.payload;
    },
    setSqReportStatus: (state, action: PayloadAction<any>) => {
      state.sqReportStatus = action.payload;
    },
    setSqReportPopupValue: (state, action: PayloadAction<any>) => {
      state.sqReportPopupValue = action.payload;
    },
    setSqReportTabChange: (state, action: PayloadAction<any>) => {
      state.sqReportTabChange = action.payload;
    }
  }
});

export const { setSqReportStatus, setSqReportPopupValue, setSqReportTabChange, setReportCMPArr, setSelectedRowData } =
  sqReport.actions;
